import styles from './list.module.scss';
import MaterialList from '@mui/material/List';
import MaterialListItem from '@mui/material/ListItem';
import MaterialListItemAvatar from '@mui/material/ListItemAvatar';
import MaterialListItemButton from '@mui/material/ListItemButton';
import MaterialListItemIcon from '@mui/material/ListItemIcon';
import MaterialListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import MaterialListItemText from '@mui/material/ListItemText';
import MaterialListSubheader from '@mui/material/ListSubheader';

/* eslint-disable-next-line */
export interface ListProps {
  children: any,
  // classes?: object,
  component?: any,
  dense?: boolean,
  disablePadding?: boolean,
  subheader?: any,
  sx?: any,
  className?: string
}

export interface ListItemProps {
  alignItems?: 'center' | 'flex-start',
  // autoFocus?: boolean,
  // button?: boolean,
  children: any,
  // classes?: object,
  component?: any,
  // components?: any,
  // componentsProps?: object,
  // ContainerComponent?: any,
  // ContainerProps?: object,
  // dense?: boolean,
  disabled?: boolean,
  disableGutters?: boolean,
  disablePadding?: boolean,
  onClick?: (...args: any[]) => void,
  // divider?: boolean,
  secondaryAction?: any,
  // selected?: boolean,
  sx?: any,
  className?: string
}

export interface ListItemAvatarProps {
  children: any,
  // classes?: object,
  sx?: any,
  className?: string
}

export interface ListItemButtonProps {
  // alignItems?:
  // 'center'
  // | 'flex-start',
  // autoFocus?: boolean,
  children: any,
  // classes?: object,
  component?: any,
  // dense?: boolean,
  disabled?: boolean,
  disableGutters?: boolean,
  // divider?: boolean,
  // focusVisibleClassName?: string,
  selected?: boolean,
  // sx?: any
  onClick?: (...args: any[]) => void
  sx?: any,
  to?: any,
  className?: string
}

export interface ListItemIconProps {
  children: any,
  // classes?: object,
  // sx?: any
  className?: string
}

export interface ListItemSecondaryActionProps {
  children: any,
  // classes?: object,
  sx?: any
}

export interface ListItemTextProps {
  children?: any,
  // classes?: object,
  // disableTypography?: boolean,
  // inset?: boolean,
  primary?: any,
  primaryTypographyProps?: object,
  secondary?: any,
  // secondaryTypographyProps?: object,
  sx?: any
  className?: string
}

export interface ListSubheaderProps {
  children?: any,
  // classes?: object,
  // color?:
  // 'default'
  // | 'inherit'
  // | 'primary',
  component?: any,
  // disableGutters?: boolean,
  // disableSticky?: boolean,
  // inset?: boolean,
  sx?: any
  className?: string
}

export function List(props: ListProps) {
  return (
    <MaterialList
      component={props.component}
      subheader={props.subheader}
      dense={props.dense}
      disablePadding={props.disablePadding}
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialList>
  );
}

export function ListItem(props: ListItemProps) {
  return (
    <MaterialListItem
      secondaryAction={props.secondaryAction}
      disableGutters={props.disableGutters}
      disablePadding={props.disablePadding}
      component={props.component}
      className={props.className}
      sx={props.sx}
      onClick={props.onClick}
      alignItems={props.alignItems}
      disabled={props.disabled}>
      {props.children}
    </MaterialListItem>
  );
}

export function ListItemAvatar(props: ListItemAvatarProps) {
  return (
    <MaterialListItemAvatar
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialListItemAvatar>
  );
}

export function ListItemButton(props: ListItemButtonProps) {
  return (
    <MaterialListItemButton
      onClick={props.onClick}
      disableGutters={props.disableGutters}
      sx={props.sx}
      component={props.component}
      selected={props.selected}
      disabled={props.disabled}
      to={props.to}
      className={props.className}>
      {props.children}
    </MaterialListItemButton>
  );
}

export function ListItemIcon(props: ListItemIconProps) {
  return (
    <MaterialListItemIcon className={props.className}>
      {props.children}
    </MaterialListItemIcon>
  );
}

export function ListItemSecondaryAction(props: ListItemSecondaryActionProps) {
  return (
    <MaterialListItemSecondaryAction
      sx={props.sx}>
      {props.children}
    </MaterialListItemSecondaryAction>
  );
}

export function ListItemText(props: ListItemTextProps) {
  return (
    <MaterialListItemText
      primary={props.primary}
      secondary={props.secondary}
      className={props.className}
      sx={props.sx}
      primaryTypographyProps={props.primaryTypographyProps}>
      {props.children}
    </MaterialListItemText>
  );
}

export function ListSubheader(props: ListSubheaderProps) {
  return (
    <MaterialListSubheader
      component={props.component}
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialListSubheader>
  );
}

export default List;